// @core/api/endpoints/product/create_product_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateProductCategoryRequest,
  ProductCategoryResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Create product category
 * Creates a new product category for organizing the marketplace catalog. Categories can be hierarchical.
 */
export async function CreateProductCategory(
  data: CreateProductCategoryRequest,
  options?: RequestOptions
): Promise<ProductCategoryResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/products/categories`;
  const requestOptions = options;
  return client.post<ProductCategoryResponse>(requestPath, data, requestOptions);
}
